import {
    ActionType,
    getAuthUserInfoAction,
} from "./actions";
import { createSlice } from "@reduxjs/toolkit";

export type AuthState = Readonly<{
    id: string,
    name: string,
    role: string,
    email: string
    processing: number
}>;

const authInitialState: AuthState = {
    id: "",
    name: "",
    role: "",
    email: "",
    processing: 0,
};

const slice = createSlice({
    name: ActionType.base,
    initialState: authInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getAuthUserInfoAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getAuthUserInfoAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { id, name, role, email } = payload;
                    state.id = id;
                    state.name = name;
                    state.role = role;
                    state.email = email;
                    state.processing -= 1;
                }
            )
            .addCase(
                getAuthUserInfoAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const authReducer = slice.reducer; 
